import { language_enum } from '@predium/enums';
import { COMMON_DATE_FORMATS, formatDateToLocale } from '@predium/utils';
import { isNil } from 'lodash';

export const getScenarioPortfolioName = (portfolioName?: string | null) => {
  if (isNil(portfolioName) || portfolioName === '') {
    return '–';
  }

  return portfolioName;
};

export const getScenarioOwner = (firstName: string | null | undefined, lastName: string | null | undefined) => {
  const fullName = `${firstName ?? ''}${lastName ? ` ${lastName}` : ''}`.trimStart();

  return `${!fullName ? '–' : fullName}`;
};

export const getScenarioCreatedAt = (createdAt: string | DateTime | null | undefined, language: language_enum) => {
  return createdAt ? formatDateToLocale(createdAt, COMMON_DATE_FORMATS.DAY_MONTH_YEAR, language) : '–';
};
